<ng-container *ngIf="loading">
  <div class="prop-info detail-info">
    <div class="prop-detail">
      <h2><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
          [height]="'25px'"></app-skeleton-loader></h2>
      <div class="prop-list">
        <ul>
          <li><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'15px'"></app-skeleton-loader></li>
          <li><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'15px'"></app-skeleton-loader></li>
          <li><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'15px'"></app-skeleton-loader> </li>
        </ul>
        <ul>
          <li><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'15px'"></app-skeleton-loader></li>
          <li><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'15px'"></app-skeleton-loader></li>
          <li><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'15px'"></app-skeleton-loader></li>
        </ul>
      </div>
      <div style="width: 45%;">
        <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView" [height]="'35px'"></app-skeleton-loader>
      </div>
      <div class="property-cat" style="width: 40%;">
        <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView" [height]="'25px'"></app-skeleton-loader>
      </div>
      <div class="land-info">
        <div style="width: 30%;">
          <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
            [height]="'25px'"></app-skeleton-loader>
        </div>
        <div class="info-land">
          <div class="skel-info">
            <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'65px'"></app-skeleton-loader>
          </div>
          <div class="skel-info">
            <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'65px'"></app-skeleton-loader>
          </div>
          <div class="skel-info">
            <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'65px'"></app-skeleton-loader>
          </div>
          <div class="skel-info">
            <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'65px'"></app-skeleton-loader>
          </div>
        </div>
      </div>
      <div class="property-zone property-builtup">
        <div style="width: 40%;">
          <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
            [height]="'25px'"></app-skeleton-loader>
        </div>
        <div class="skel--info">
          <div><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'25px'"></app-skeleton-loader></div>
          <div><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'25px'"></app-skeleton-loader></div>
          <div><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'25px'"></app-skeleton-loader></div>
          <div><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'25px'"></app-skeleton-loader></div>
          <div><app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView"
              [height]="'25px'"></app-skeleton-loader></div>
        </div>
      </div>
    </div>
    <!-- <div class="prop-img">
            <app-skeleton-loader [loaderSize]="1" [reportType]="chartView.overView" [height]="'250px'"></app-skeleton-loader>
        </div> -->
  </div>
</ng-container>

<div class="prop-info detail-info" *ngIf="PropertyDetails && !loading">
  <div class="prop-detail">
    <div class="d-flex justify-content-between align-items-center prop-img property-details">
      <h2>{{(PropertyDetails?.property_name && PropertyDetails?.property_uid)? PropertyDetails.property_name + ' (' +
        (PropertyDetails?.parent_property_uid || PropertyDetails.property_uid) + ')' : PropertyDetails.property_uid}}</h2>
      <button class="dwld-property-detail" (click)="downloadPdfReport()">
        <img src="../../../../assets/images/report-dwld.svg" alt="">
        {{"reports.dwld_property_report" | translate}}
      </button>
    </div>
    <div class="prop-list">
      <ul>
        <li *ngIf="PropertyDetails?.project_name"><span>{{'reports.projectName' | translate}}: </span> {{
          PropertyDetails.project_name }}</li>
        <li *ngIf="PropertyDetails?.address"><span>{{'reports.address' | translate}} : </span> {{
          PropertyDetails.address}}
           <button
                    class="map-icon-btn"
                    (click)="openInGoogleMaps()"
                    [matTooltip]="'reports.Locate_on_Google_Maps' | translate"
                    matTooltipPosition="above">
                    <img src="assets/images/google.svg" alt="Google Maps" class="google-svg-icon">
                </button>
          </li>
        <li *ngIf="PropertyDetails?.land_number"><span>{{'reports.landNumber' | translate }} : </span> {{
          PropertyDetails.land_number}}</li>
        <li *ngIf="PropertyDetails?.paci_number"><span>{{'PACI No' | translate}} :
          </span>{{PropertyDetails.paci_number}}</li>
        <li *ngIf="PropertyDetails?.plan_number"><span>{{'reports.plan_number' | translate}} : </span> {{
          PropertyDetails.plan_number}} </li>
      </ul>
      <ul>
        <li *ngIf="PropertyDetails?.construction_status && property_cat !== propertyCategoryEnum.VillaHouse">
          <span>{{'reports.constructionStatus' | translate}} : </span> {{ PropertyDetails.construction_status |
          translate }} </li>
        <li *ngIf="PropertyDetails?.developer_name && property_cat !== propertyCategoryEnum.VillaHouse"><span>{{'reports.developer' |
            translate}} : </span> {{ PropertyDetails.developer_name}} </li>
        <li *ngIf="PropertyDetails?.year_of_build && property_cat !== propertyCategoryEnum.VillaHouse"><span>{{'reports.yearOfBuild' |
            translate}}: </span> {{ PropertyDetails.year_of_build }} <ng-container
            *ngIf="PropertyDetails?.property_age">({{PropertyDetails?.property_age + ('y'| translate)}})</ng-container>
        </li>
          <li *ngIf="PropertyDetails?.zoning"><span>{{'reports.Municipal_land_zone' | translate}}: </span> {{
          PropertyDetails.zoning }}</li>
      </ul>
    </div>
    <ng-container *ngIf="PropertyDetails?.land_information?.length">
      <div class="land-info">
        <h2>{{ ('reports.land_information' | translate)}} <i class="contant-icon" matTooltipPosition="above"
            matTooltipClass="custom-tooltip" [matTooltip]="'reports.thisSectionProvidesBasicDetails' | translate"></i>
        </h2>
        <div class="info-land">
          <ng-container *ngFor="let land_information of PropertyDetails.land_information, let i = index">
            <div class="p-info" [ngClass]="'p-info' + i"
              *ngIf="land_information?.value || (land_information?.value == '0' && land_information.key == 'corners')">
              <h6> {{('reports.'+land_information.key) | translate}}</h6>
              <div class="p-info-content" [matTooltipPosition]="'below'"
                [matTooltip]="getTooltipValue(land_information.value)">
                <ng-container *ngIf="land_information?.value == '0' && land_information.key == 'corners'"><span>{{
                    'reports.no_corner' | translate}}</span></ng-container>
                <ng-container *ngIf="land_information?.value != '0'"><span
                    [ngClass]="{'usage' : land_information.key === 'usage'}">{{
                    getRoundOffValue(land_information.value)}}</span></ng-container>
                <sup
                  *ngIf="land_information.key === 'land_area' || land_information.key === 'setback' || land_information.key === 'retail_GLA' || land_information.key === 'office_GLA' || land_information.key === 'gla'">{{unitType
                  | translate}}</sup>
                <sup *ngIf="land_information.key === 'frontage'">{{unitTypeMeter | translate}}</sup>
                <span *ngIf="land_information.key === 'permissible' || land_information.key === 'whiteland_tax'">%</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- <div class="prop-img">
        <div class="images d-flex">
          <img *ngIf="PropertyDetails.corners == '0'" src="../../../../assets/images/property-img/corner_0.svg" alt="Image">
          <img *ngIf="PropertyDetails.corners == '1'" src="../../../../assets/images/property-img/corner_1.svg" alt="Image">
          <img *ngIf="PropertyDetails.corners == '2'" src="../../../../assets/images/property-img/corner_2.svg" alt="Image">
          <img *ngIf="PropertyDetails.corners != '0' && PropertyDetails.corners != '1' && PropertyDetails.corners != '2'" src="../../../../assets/images/property-img/corner_4.svg" alt="Image">
        </div>
        <button class="dwld-property-detail" (click)="downloadPdfReport()">
          <img src="../../../../assets/images/report-dwld.svg" alt="">
          {{"reports.dwld_property_report" | translate}}
        </button>
    </div> -->
  <div *ngIf="downloadLoder" class="downloadLoder d-flex align-items-center justify-content-center">
    <img class="vsloader" style="width: 80px;" src="assets/images/loading.gif" alt="">
  </div>
</div>

<div class="prop-info detail-info" *ngIf="PropertyDetails && !loading">
  <div class="prop-detail">
  <ng-container
   *ngIf="PropertyDetails?.property_information?.property_grade
    || PropertyDetails?.property_information?.property_category
    || PropertyDetails?.property_information?.warehouse_type
    || PropertyDetails?.property_information?.property_sub_category
    || PropertyDetails?.property_information?.usages
  ">
      <div class="property-zone property-builtup">
        <h4>{{'reports.property_information' | translate}}</h4>
        <div class="zoning-info builtup-info">

          <span *ngIf="PropertyDetails?.property_information?.property_grade">
            {{'reports.grade' | translate}}:
            <strong class="">{{PropertyDetails?.property_information?.property_grade}}</strong>
          </span>

          <ng-container *ngIf="PropertyDetails?.property_information?.property_category && property_cat == propertyCategoryEnum.RetailFbAndEntertainment">
             <ng-container *ngIf="PropertyDetails?.property_information?.property_category as catsubCategories">
              <span *ngFor="let item of getUniqueValues(catsubCategories)">
                <strong>{{ item }}</strong>
              </span>
            </ng-container>
          </ng-container>

        <ng-container *ngIf="property_cat !== propertyCategoryEnum.RetailFbAndEntertainment">
          <ng-container *ngIf="PropertyDetails?.property_information?.property_sub_category as subCategories">
            <span *ngFor="let item of getUniqueValues(subCategories)">
              <strong>{{ item }}</strong>
            </span>
          </ng-container>
        </ng-container>


          <span *ngIf="PropertyDetails?.property_information?.warehouse_type">
            <strong>{{PropertyDetails?.property_information?.warehouse_type}}</strong>
          </span>

          <span *ngIf="PropertyDetails?.property_information?.usages">
            {{'reports.usages' | translate}}:
            <strong>{{PropertyDetails?.property_information?.usages}}</strong>
          </span>

        </div>
      </div>
    </ng-container>


  <div class="property-zone property-builtup" *ngIf="PropertyDetails?.builtup_info?.floors > 1 || PropertyDetails?.builtup_info?.furnishing_status
      || PropertyDetails?.builtup_info?.bedrooms || PropertyDetails?.builtup_info?.balconies
      || PropertyDetails?.builtup_info?.parking || PropertyDetails?.builtup_info?.leasable_area || PropertyDetails?.builtup_info?.retail_gla
      || PropertyDetails?.builtup_info?.office_gla || PropertyDetails?.builtup_info?.brands > 0 || PropertyDetails?.builtup_info?.storage_area
      || PropertyDetails?.builtup_info?.far">
      <h4>{{'reports.builtup_information' | translate}}</h4>
      <div class="zoning-info builtup-info">

        <!-- Furnishing Status -->
        <span *ngIf="PropertyDetails?.builtup_info?.furnishing_status">
          <!-- {{'reports.finish' | translate}}: -->
          <strong>{{PropertyDetails?.builtup_info?.furnishing_status || ('na' | translate)}}</strong>
        </span>

        <!-- Floors -->
        <span
          *ngIf="PropertyDetails?.builtup_info?.floors && property_cat !== propertyCategoryEnum.IndustryWorkshopWarehouse && PropertyDetails?.builtup_info?.floors > 1">
          <strong>{{PropertyDetails?.builtup_info?.floors}} {{'reports.floor' | translate}}</strong>
        </span>

           <!-- Brands -->
        <span *ngIf="PropertyDetails?.builtup_info?.brands || PropertyDetails?.builtup_info?.brands > 0">
          <strong>{{PropertyDetails?.builtup_info?.brands}} {{'reports.brands' | translate}}</strong>
        </span>

        <!-- Bedrooms -->
        <span *ngIf="PropertyDetails?.builtup_info?.bedrooms">
          {{'reports.bed_rooms' |  translate}}:
          <strong>{{PropertyDetails?.builtup_info?.bedrooms | number : '1.0-0'}} </strong>
        </span>

        <!-- Balconies -->
        <span *ngIf="PropertyDetails?.builtup_info?.balconies">
          {{'reports.balconies' |  translate}}:
          <strong>{{PropertyDetails?.builtup_info?.balconies | number : '1.0-0'}} </strong>
        </span>

        <!-- Parking -->
        <span *ngIf="PropertyDetails?.builtup_info?.parking">
          {{'reports.parking' | translate}}:
          <strong>{{PropertyDetails?.builtup_info?.parking | number : '1.0-0'}}</strong>
        </span>

        <!-- Leasable Area -->
        <span *ngIf="PropertyDetails?.builtup_info?.leasable_area && property_cat !== propertyCategoryEnum.VillaHouse">
          {{'reports.leasable_area' | translate}}:
          <strong>{{PropertyDetails?.builtup_info?.leasable_area | number : '1.0-0'}} {{'reports.sqm_unit' | translate}}</strong>
        </span>

        <!-- Storage Area -->
        <span *ngIf="PropertyDetails?.builtup_info?.storage_area">
          {{'reports.storage_area' | translate}}:
          <strong>{{PropertyDetails?.builtup_info?.storage_area | number : '1.0-0'}} {{'reports.sqm_unit' | translate}}</strong>
        </span>
        <!-- Retail GLA -->
        <span *ngIf="PropertyDetails?.builtup_info?.retail_gla">
          {{'reports.retail_GLA' |  translate}}:
          <strong>{{PropertyDetails?.builtup_info?.retail_gla | number : '1.0-0'}} {{'reports.sqm_unit' | translate}}</strong>
        </span>
        <!-- Office GLA -->
        <span *ngIf="PropertyDetails?.builtup_info?.office_gla">
         {{'reports.office_GLA' | translate}}:
          <strong> {{PropertyDetails?.builtup_info?.office_gla | number : '1.0-0'}} {{'reports.sqm_unit' | translate}}</strong>
        </span>

        <!-- FAR -->
        <span *ngIf="PropertyDetails?.builtup_info?.far">
          {{'FAR' | translate}}:
          <strong>{{PropertyDetails?.builtup_info?.far}} %</strong>
        </span>

      </div>
    </div>


  </div>


</div>
